import { render, staticRenderFns } from "./YourMarginPercent.vue?vue&type=template&id=4aeca95f&scoped=true"
import script from "./YourMarginPercent.vue?vue&type=script&lang=ts"
export * from "./YourMarginPercent.vue?vue&type=script&lang=ts"
import style0 from "./YourMarginPercent.vue?vue&type=style&index=0&id=4aeca95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeca95f",
  null
  
)

export default component.exports